import { render } from "./profile-settings.vue?vue&type=template&id=2f54d895&scoped=true"
import script from "./profile-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-settings.vue?vue&type=script&setup=true&lang=js"

import "./profile-settings.vue?vue&type=style&index=0&id=2f54d895&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f54d895"],['__file',"src/views/administration/users/profile-settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f54d895"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f54d895', __exports__)) {
    api.reload('2f54d895', __exports__)
  }
  
  module.hot.accept("./profile-settings.vue?vue&type=template&id=2f54d895&scoped=true", () => {
    api.rerender('2f54d895', render)
  })

}


export default __exports__